module.exports = __webpack_public_path__ + "img/icon4.4155531c.png";